import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { modalPrefixCls } from "@/base/components/modal/Modal.component";
import { THEME_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Modal">> = () => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${modalPrefixCls}`]: {
      [`.${modalPrefixCls}-footer`]: {
        position: "sticky",
        bottom: 0,
        paddingBlock: 12,
        margin: "12px 0 0",
      },
    },
  },
});

export const useModalStyle = genComponentStyleHook(
  ["Modal", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
